import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Button from "./Button";

function AktuellesTabs() {
    const [activeTab, setActiveTab] = useState("alle");


    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [aktuelles, setAktuelles] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);


    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".tab-content .col-inner h4"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 100);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, [aktuelles, activeTab]);


    const [isMoreLoading, setIsMoreLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [pageSize] = useState(9);
    const [total, setTotal] = useState(0);

    // ================= FETCH DATA =================
    const getPageData = async (pageNumber = 1, loadMore = false) => {
        if (loadMore) {
            setIsMoreLoading(true);
        } else {
            setIsLoading(true);
        }

        try {
            const response = await fetch(
                `https://backend.bgzurlinden.ch/api/aktuelles?populate[aktuelles_kategorie][populate]=*&populate[Bannerbereich][on][header.header-1-titel-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&pagination[page]=${pageNumber}&pagination[pageSize]=${pageSize}&sort[0]=sortOrder`
            );

            const data = await response.json();

            if (data?.data) {
                if (loadMore) {
                    setAktuelles((prev) => [...prev, ...data.data]);
                } else {
                    setAktuelles(data.data);
                }

                setTotal(data?.meta?.pagination?.total || 0);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
            setIsMoreLoading(false);
        }
    };

    // initial load
    useEffect(() => {
        getPageData(1);
    }, []);

    // ================= LOAD MORE =================
    const handleLoadMore = () => {
        const nextPage = page + 1;

        setPage(nextPage);

        getPageData(nextPage, true);
    };

    const truncateBlocks = (blocks, maxLength = 120) => {
        if (!blocks) return "";

        let text = "";

        for (let block of blocks) {
            if (block.children) {
                for (let child of block.children) {
                    text += child.text;

                    if (text.length >= maxLength) {
                        return text.slice(0, maxLength) + "...";
                    }
                }
            }
        }

        return text;
    };

    // useEffect(() => {
    //     if (categories.length > 0 && !activeTab) {
    //         setActiveTab(categories[0].id);
    //     }
    // }, [aktuelles]);

    const categories = [
        { id: "alle", Titel: "Alle" },
        ...new Map(
            aktuelles?.map(item => [
                item.aktuelles_kategorie?.id,
                item.aktuelles_kategorie
            ])
        ).values()
    ];

    return (
        <div className="tab_wrapper aktuelles_tabs">
            {/* Nav Tabs */}
            <div className='tabs-view-flex sec-orange-color'>
                {/* <h2 className="text-darkgrey">Proin gravida </h2> */}
                <ul className="nav nav-tabs">
                    {categories.map((cat) => (
                        <li className="nav-item" key={cat.id}>
                            <button
                                className={`nav-link ${cat?.Farbe?.split(" ")[0] ? cat?.Farbe?.split(" ")[0] : "black" }-nav-link ${activeTab === cat.id ? "active" : ""}`}
                                onClick={() => setActiveTab(cat.id)}
                            >
                                {cat.Titel}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Tab Content */}
            <div className="tab-content mt-4">
                <div className="tab-pane active">
                    <div className="row">
                        {aktuelles?.filter(
                            item => activeTab === "alle" ? true : item.aktuelles_kategorie?.id === activeTab
                        )?.map((aktuelle, index) => {
                            const banner = aktuelle?.Bannerbereich?.[0];
                            const module = aktuelle?.Modul?.[0];

                            return (
                                <div className="col-sm-6 col-lg-4 col-item mt-4 mt-lg-5">
                                    <Link to={`/aktuelles/${aktuelle?.slug}`} className='col-inner'>
                                        <figure>
                                            <img src={`https://backend.bgzurlinden.ch${module?.Bild[0].url}`} alt='#' />
                                            <span className={`bg-${aktuelle?.aktuelles_kategorie?.Farbe?.split(" ")[0]}`}>{aktuelle?.aktuelles_kategorie?.Titel}</span>
                                        </figure>
                                        <div className='figcaption'>
                                            <h4 className="fs_26 fw-550 text-darkgrey">{aktuelle?.Titel}</h4>
                                            {banner?.Beschreibung && (
                                                <p>{truncateBlocks(banner.Beschreibung, 70)}</p>
                                            )}
                                            {/* <p>Hier kommt der Lead klein at vero eos et accusam et justodu odolores et earebum...</p> */}
                                            <div className="btn_date_flex">
                                                <div className="button round_btn btn-blue-color">lesen &nbsp;
                                                    <span>
                                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit" />
                                                            <path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit" />
                                                        </svg>
                                                    </span>
                                                </div>
                                                <span className='post-date'>
                                                    {new Date(aktuelle?.Publikation).toLocaleDateString('de-DE', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                    })}
                                                </span>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )

                        })}
                    </div>
                    {aktuelles?.length < total && (
                        <div className="btn-container d-flex justify-content-center mt-4 mt-lg-5">
                            <button
                                className="button border-btn btn-theme-color"
                                onClick={handleLoadMore}
                                disabled={isMoreLoading}
                            >
                                {isMoreLoading ? "Loading..." : "mehr"}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AktuellesTabs;